module.exports = __webpack_public_path__ + "img/1.caab0ec9.png";